import React, { useEffect, useState } from 'react';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import {
    Button,
    DialogActions,
    Dialog,
    DialogContent,
    IconButton,
    DialogTitle,
    Slide
} from '@material-ui/core';
import { connect } from "react-redux";
import CloseIcon from '@material-ui/icons/Close';
import { BiltyReceiptIcon } from '../../../components/icons';
import { withRouter, useHistory, useLocation } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
    widthV1: {
        width: 518,
        maxWidth: 518
    },
    dialogTitleV1: {
        paddingTop: 12,
        paddingRight: 12,
        paddingLeft: 24,
        paddingBottom: '0px !important',
        "& .MuiTypography-root": {
            display: 'flex',
            justifyContent: 'flex-end'
        }
    },
    divV1: {
        fontSize: 16,
        fontWeight: 500
    },
    divV2: {
        fontSize: 32,
        fontWeight: 500,
        marginTop: -10
    },
    divV3: {
        textAlign: 'center'
    },
    closeIcon: {
        color: 'grey',
        fontSize: 18
    },
    dialogContentV1: {
        paddingLeft: 64,
        paddingRight: 64,
        paddingBottom: '0px !important',
        paddingTop: 0
    },
    divV4: {
        fontSize: 20,
        textAlign: 'center',
        marginTop: 16
    },
    dialogActionsV1: {
        paddingLeft: 80,
        paddingRight: 80,
        paddingTop: 24,
        paddingBottom: '32px !important',
        display: 'flex',
        justifyContent: 'center'
    },
    buttonV1: {
        textTransform: 'capitalize',
        color: 'white',
        backgroundColor: '#5170f0',
        fontWeight: 300,
        paddingTop: 17,
        paddingBottom: 17,
        paddingRight: 64,
        paddingLeft: 64,
        borderRadius: 8,
        '&:hover': {
            backgroundColor: '#5170f0'
        }
    },
    paper1: {
        borderRadius: 8
    },
    imgV1: {
        width: 200,
        height: 200
    },
    divV5: {
        textAlign: 'center'
    }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const BiltyPopUp = ({ open, onClose, onBilty }) => {

    const [dialogOpen, setDialogOpen] = useState(open);

    const classes = useStyles();

    const handleClose = () => {
        setDialogOpen(false);
        onClose();
        localStorage.setItem('BiltyPopUpShown', true);
    }

    const goToBilty = () => {
        onBilty();
        handleClose();
    }


    return (
        <>
            <Dialog
                open={dialogOpen}
                fullWidth
                maxWidth={'sm'}
                TransitionComponent={Transition}
                keepMounted
                disableEscapeKeyDown={true}
                disableBackdropClick={true}
                onClose={handleClose}
                aria-labelledby="bilty-pop-up"
                aria-describedby="bilty-pop-up-description"
                classes={{ paperWidthSm: classes.widthV1, paperScrollPaper: classes.paper1 }}
            >
                <DialogTitle className={classes.dialogTitleV1}>
                    <div>
                        <IconButton onClick={handleClose} >
                            <CloseIcon className={classes.closeIcon} />
                        </IconButton>
                    </div>
                </DialogTitle>

                <DialogContent className={classes.dialogContentV1}>
                    <div className={classes.divV3}>
                        <div className={classes.divV1}>Introducing</div>
                        <div className={classes.divV2}>ONLINE BILTY</div>
                    </div>
                    <div className={classes.divV5}>
                        <BiltyReceiptIcon className={classes.imgV1} />
                    </div>
                    <div className={classes.divV4}>Create Bilty and Document your trip easily</div>
                </DialogContent>

                <DialogActions className={classes.dialogActionsV1}>
                    <Button variant="contained" className={classes.buttonV1} onClick={() => { goToBilty() }}>
                        Create Bilty for your Trips now
                    </Button>
                </DialogActions>
            </Dialog>


        </>
    )
}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(BiltyPopUp);